import angular from 'angular';
import uiRouter from 'angular-ui-router';
import commonchangedtodrgComponent from './commonchangedtodrg.component';

let commonchangedtodrgModule = angular.module('commonchangedtodrg', [
  uiRouter
])

.component('commonchangedtodrg', commonchangedtodrgComponent);

export default commonchangedtodrgModule;



// WEBPACK FOOTER //
// ./client/app/common/reports/commonchangedtodrg/commonchangedtodrg.js